<!--
Author: TangChen
Date: 2018-10-17
Desc: 修改查询密码页面，由index.js 配置引入
 -->
<template>
    <div :class="'bizcomp-query-lpwd bizcomp ' + className">
        <comp-title :title="title" />
        <change-pwd :way="way" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import changePwd from "@/components/acctInfo/changePwd.vue";
export default {
    name: "QueryLpwd",
    components: {
        changePwd
    },
    mixins: [mixin],
    data () {
        return {
            way: "query",
            text: "查询"
        };
    },
    methods: {
    }
};
</script>
<style lang="scss">
  @import '../../assets/css/varibles';
  .bizcomp-query-lpwd {
  }
</style>
